import { BaseClient } from 'clients/BaseClient/BaseClient';

import { hosts } from 'config';
import { DownloadExcelHandler, GetAllHandler, GetPermissionsHandler, RefreshTokenHandler } from './types';

export class UsersClient extends BaseClient {
  constructor() {
    super();
  }

  getPermissions: GetPermissionsHandler = () => {
    return this.request({
      url: `${hosts.rrLegacyApi()}/api/services/app/Permission/GetAllPermissions`,
      method: 'GET',
    });
  };

  downloadExcel: DownloadExcelHandler = () => {
    return this.request({
      url: `${hosts.rrLegacyApi()}/api/services/app/User/GetUsersToExcel`,
      method: 'GET',
    }).then(({ data: { result: { fileType = null, fileName = null, fileToken = null } = {} } = {} }) => {
      // No auth on this endpoint, it uses file token to download
      if (fileType && fileName && fileToken) {
        const url = `${hosts.rrLegacyApi()}/File/DownloadTempFile?fileType=${fileType}&fileToken=${fileToken}&fileName=${fileName}`;
        window.location.assign(url);
      }
    });
  };

  getAllActive: GetAllHandler = () => {
    return this.request({
      url: `${hosts.userApi()}/users/?is_active=true`,
    });
  };

  refreshToken: RefreshTokenHandler = () => {
    return this.request({
      url: `${hosts.userApi()}/auth/refresh/`,
      method: 'POST',
      withCredentials: true,
    });
  };
}

export const usersClient = new UsersClient();
